export default __webpack_public_path__ + "static/unpacked_array_multi_dim-13174f98fd4f87c383205321c6bb8e8c.svg";